<template>
    <div class="kx-home-content-box">
        <div>
            <div class="kx-head-container">
                <div class="kx-left-head-container" @click="backHome">
                    <svg t="1766639305795"  class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                </div>
                <div class="kx-right-head-container">{{this.categoryName}}</div>
                <div class="kx-left-head-container">
                </div>
            </div>
            <div class="home-page-container">
                <div class="hot-item" v-for="item in dataList" :key="item" @click="viewVideo(item.videoId)">
                    <div class="bymy-video-img">
                        <img class="bymy-img-100" :src="item.coverUrl" alt="">
                    </div>
                    <div class="bymy-video-name">{{item.title}}</div>
                </div>
                <div class="div-100" v-if="dataList&&dataList.length===0">
                    <dataEmpty title="暂无数据" />
                </div>
            </div>
            <div class="bymy-page-container" v-if="dataList&&dataList.length>0">
                <pageTag :background="true"
                         :pageSizes="[20, 30, 40]"
                         v-show="total > 0"
                         :total="total"
                         v-model:page.sync="queryParams.pageNum"
                         v-model:limit.sync="queryParams.pageSize"
                         @pagination="queryCategoryVideo" />
            </div>
        </div>
    </div>
</template>

<script>
import { timestampToTime } from "@/utils/date";
import DataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import {humanityBymyVideoList} from "@/api/admin/home";
export default {
    name: "humKxjMode",
    components: {pageTag, DataEmpty},
    props:{
        cname:{
            type: String,
            default:null
        },
    },
    watch:{
        cname(newValue,oldValue){
            this.categoryName = newValue.split("&")[0];
            this.queryParams.categoryName = newValue.split("&")[0];
            this.queryCategoryVideo();
        },
    },
    data() {
        return {
            timestampToTime,
            showMode:'page',
            categoryName:'',
            editionType:this.$storage.get('editionType'),
            category:{},
            videoList:[],
            queryParams:{
                pageNum: 1,
                pageSize: 20,
                categoryName: '',
            },
            total: 0,
            dataList:[],
            videoId:'',
        };
    },
    created() {},
    mounted() {
    },
    computed: {},
    methods: {
        viewVideo(videoId){
            this.videoId = videoId+"&"+Math.random();
            this.$emit('list-play-video',this.videoId);
        },
        queryCategoryVideo(e){
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            humanityBymyVideoList(this.queryParams).then(res => {
                if (res.data.code===1){
                    this.total = res.data.data.total;
                    this.dataList = res.data.data.list;
                }else {
                    this.$message.error(res.data.msg);
                }
            })
        },
        backHome(){
            this.$emit('change-home-mode',"homePage");
        },
    },
}

</script>

<style scoped>
.kx-home-content-box{
    width: 100%;
    height: auto;
    background-color: #fff;
    border-radius: 28px;
}
.kx-head-container{
    width: 100%;
    height: 54px;
    display: flex;
    margin: auto;
    padding: 10px 10px 8px 10px;
    box-sizing: border-box;
}
.kx-left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.kx-right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #0d55a4;
    line-height: 44px;
    font-weight: bold;
}
.home-page-container{
    width: 100%;
    height: calc(100vh - 290px)!important;
    margin: auto;
    overflow-x: hidden;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    padding-left: 10px;
    box-sizing: border-box;
}
/* 隐藏滚动条 */
.home-page-container::-webkit-scrollbar {
    display: none;
}
.hot-item{
    cursor: pointer;
    position: relative;
    width: 25%;
    border-radius: 4px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .04);
    overflow: hidden;
    margin-bottom: 30px;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}

.bymy-video-img{
    width: 100%;
    height: 120px;
    border-radius: 4px!important;
}
.bymy-img-100{
    width: 100%;
    height: 100%;
    border-top-left-radius: 4px!important;
    border-top-right-radius: 4px!important;
}
.bymy-video-name{
    width: 100%;
    height: 60px;
    padding: 16px 12px 16px;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap !important;
    color: #333;
    font-weight: bold;
}

.bymy-page-container{
    width: 100%;
    height: 60px;
    display: grid;
    place-items: center;
    background-color: #fff;
    border-radius: 28px;
}
</style>